// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"216":"69e97798","267":"509ad2e2"}[chunkId] + ".chunk.css";
};